// Import polyfills and base styles
import "@zalando-internal/z-shop-js-env";
import "@zalando-internal/z-shop-css-env/src/style.css";

// External dependencies
import classnames from "classnames";
import React from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";

import eventBus from "@zalando-internal/z-shop-event-bus";
import * as tranzlate from "tranzlate";
import * as consentApi from "@zalando-internal/zalando-consent-api";

// Internal modules
import safeFetch from "./fetch-extension";

// Enable translation debugging in development
if (
  typeof window !== "undefined" &&
  window.location.search.includes("translationDebuggingMode=1")
) {
  (tranzlate as Record<string, unknown>).passThrough = true;
}

// Export all modules (webpack will transform these to AMD)
export {
  classnames,
  React as react,
  ReactDOM as "react-dom",
  ReactDOMClient as "react-dom/client",
  eventBus as "z-shop-event-bus",
  tranzlate,
  consentApi as "zalando-consent-api",
  safeFetch as "safe-fetch",
};

// Legacy CommonJS exports for backward compatibility
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    classnames,
    react: React,
    "react-dom": ReactDOM,
    "react-dom/client": ReactDOMClient,
    "z-shop-event-bus": eventBus,
    tranzlate,
    "zalando-consent-api": consentApi,
    "safe-fetch": safeFetch,
  };
}
